import React from 'react';
import { FiArrowDownRight, FiArrowUpRight } from 'react-icons/fi';
import type { ChannelMetricsResponse } from '@troia-v3/types';

import { computeDelta, formatCompact } from './formatMetrics';

type MetricKey = 'followersCount' | 'reach' | 'impressions' | 'profileViews' | 'mediaCount';
interface KpiDef {
  key: MetricKey;
  label: string;
}
const KPIS: KpiDef[] = [
  { key: 'followersCount', label: 'Seguidores' },
  { key: 'reach', label: 'Alcance' },
  { key: 'impressions', label: 'Impressões' },
  { key: 'profileViews', label: 'Visitas ao perfil' },
  { key: 'mediaCount', label: 'Publicações' },
];

interface Props {
  latest: ChannelMetricsResponse | null;
  previous?: ChannelMetricsResponse | null;
}
export const KpiRow: React.FC<Props> = ({ latest, previous }) => (
  <div className="cdash-kpis" data-testid="cdash-kpis">
    {KPIS.map((k) => {
      const v = latest?.[k.key];
      const p = previous?.[k.key];
      const delta = computeDelta(v, p);
      return (
        <div className="cdash-kpi" key={k.key} data-testid={`cdash-kpi-${k.key}`}>
          <div className="cdash-kpi-l">{k.label}</div>
          <div className="cdash-kpi-v">{formatCompact(v)}</div>
          {delta ? (
            <span className={`cdash-delta ${delta.dir}`}>
              {delta.dir === 'up' ? <FiArrowUpRight size={13} /> : delta.dir === 'down' ? <FiArrowDownRight size={13} /> : null}
              {delta.label}
            </span>
          ) : null}
        </div>
      );
    })}
  </div>
);
